import { useEffect, useState, useCallback } from 'react';
import { getToken } from '../tools/utils';
import { RootObjectOrganization } from '../types/allorganization';

export const useGetOrganization = (organizationId: string) => {
  const [data, setData] = useState<RootObjectOrganization | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchOrganization = useCallback(async () => {
    if (!organizationId) {
      console.warn("❌ No organizationId provided to useGetOrganization");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const tokenId = await getToken();
      const { REACT_APP_WEB_API, REACT_APP_HEADERKEY } = process.env;

      const url = `${REACT_APP_WEB_API}org/get-by-Id?Id=${organizationId}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenId}`,
          'Content-Type': 'application/json',
          'Head-Key': REACT_APP_HEADERKEY || '',
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch organization: ${response.statusText}`);
      }

      const result = await response.json();
      setData(result?.data || result);
    } catch (err) {
      console.error(err);
      setError('An error occurred while fetching organization data.');
    } finally {
      setIsLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    fetchOrganization();
  }, [fetchOrganization]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchOrganization,
  };
};

